import dir from "@/styles/modules/directions.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import React from "react";

interface ProTipProps {
    imageProps: React.ComponentProps<typeof VadImage>;
    content: React.ReactNode;
}

export const ProTip = ({imageProps, content}: ProTipProps) => <section className={dir.directions_tip__wrapper}>
    <div className="container">
        <div className={dir.directions_tip__block}>
            <VadImage width={192} height={268} {...imageProps}/>
            {content}
        </div>
    </div>
</section>
